import React, { Fragment, useEffect, useState } from "react";
import Dropdown from "react-bootstrap/Dropdown";
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';

export function StyleSortableContent(props) {
    const {
        attributes,
        listeners,
        setNodeRef,
        transform,
        transition,
        handle,
        isDragging,
        setActivatorNodeRef
    } = useSortable({ id: props.id });



    const style = {
        transform: CSS.Transform.toString(transform),
        transition,
        zIndex: isDragging ? 3 : null,

    };
    const cardImgPath = window.location.href.indexOf("vagaro.com") > 0 ? ("https://d396040dc4cf62cf5770-d11e112dbdab6afc64c448f17b56c3c3.ssl.cf2.rackcdn.com/WB/"):("https://f745786de3dd98dac855-36e09dc6f87385bab9d0e7ff5c0d38c7.ssl.cf2.rackcdn.com/WB/");
    const cardImgPlaceholder =
        "https://1a96a36bae7c8550901a-274b8a70320bb26e7a1e0ea7836ee429.ssl.cf2.rackcdn.com/PublicImages/Images/template-thum-empty.gif";

    const redirect = (styleId, layoutID) => {
        if (typeof styleId !== 'undefined' && styleId !== null && styleId !== "") {
            let a = document.createElement('a');
            a.target = '_self';
            a.href = "/admin/" + styleId + "/" + layoutID + "/designer?menu=sitestyling";
            a.click();
        }
    }

    return (
        <div ref={setNodeRef} style={style} className="styles-card-col" handle={handle}>
            <div className={props.businessStyleId != "" ? "styles-card selected" : "styles-card"} >
                <div className="styles-card-thum-frame">
                    <span className="dots" />
                    <img
                        className="styles-card-thum"
                        alt={props.styleTitle}
                        src={cardImgPlaceholder}
                        style={{
                            backgroundImage: `url(${cardImgPath + props.styleImage})`
                        }}
                    />
                    <div className="styles-card-overlay">
                        <Fragment>
                            <Dropdown className="moremenu dropdown size24">
                                <Dropdown.Toggle className="more-3dot">
                                    <i
                                        className="far fa-ellipsis-v"
                                        aria-hidden="true"
                                    />
                                </Dropdown.Toggle>
                                <Dropdown.Menu align="end">
                                    {props.layoutlist.length > 0 &&
                                        <Dropdown.Item onClick={(e) => { redirect(props.id, props.layoutlist[0].id) }}>
                                            Edit Style
                                        </Dropdown.Item>
                                    }
                                    {/* <Dropdown.Item onClick={(e) => { props.CreateLayout(props.id) }}>
                                        Create Layout
                                    </Dropdown.Item> */}
                                    <Dropdown.Item onClick={(e) => { props.EditStyleSetting(props.id) }}>
                                        Edit Style
                                        Settings
                                    </Dropdown.Item>
                                    <Dropdown.Item onClick={(e) => { props.DuplicateStyle(props.id) }}>
                                        Duplicate
                                    </Dropdown.Item>
                                    {props.isActive && props.isSoftDelete &&
                                        <Dropdown.Item onClick={(e) => { props.ActivateStylePopup(props.id) }}>
                                            Activate
                                        </Dropdown.Item>
                                    }
                                    {props.isActive && props.isSoftDelete == false &&
                                        <Dropdown.Item onClick={(e) => { props.DeactivateStylePopup(props.id) }}>
                                            Deactivate
                                        </Dropdown.Item>
                                    }
                                    <Dropdown.Item onClick={(e) => { props.DeleteStylePopup(props.id) }}>
                                        Delete
                                    </Dropdown.Item>
                                </Dropdown.Menu>
                            </Dropdown>
                            <button className="dragbutton" {...attributes} {...listeners}>
                                <i className="far fa-bars"></i>
                            </button>
                        </Fragment>
                        <Fragment>
                            {props.isExistStyle == true && props.businessStyleId == "" &&
                                <div className="btn-row">
                                    <a
                                        onClick={(e) => { props.BusinessChangeStyle(props.id) }}
                                        className={"w-button w-button-primary style-"+props.id}
                                    >
                                        Change Style
                                    </a>
                                </div>
                            }
                            <div className="btn-row">
                                <a
                                    onClick={(e) => {props.layoutlist.length > 0 ? props.showLayout(props.id) : props.Layoutalert()}}
                                    className={"w-button w-button-primary style-"+props.id}
                                >
                                    Start With This Style
                                </a>
                            </div>
                        </Fragment>
                    </div>
                </div>
                <div className="styles-card-item">
                    <h3 className="">
                        {props.styleTitle}

                        {props.isNewest &&
                            <span className="badge badge-primary">
                                NEW
                            </span>}
                        {" "}
                        {props.isPopular &&
                            <span className="badge badge-secondary">
                                POPULAR
                            </span>
                        }
                        {props.isActive && props.isSoftDelete &&
                            <span className="badge badge-secondary badge-inactive">
                                INACTIVE
                            </span>
                        }

                    </h3>
                </div>

            </div>
        </div>
    );
}